/**
 * Modal pour saisir la raison de rejet d un document CEE.
 * Composant controlle (parent gere isOpen + onConfirm + onCancel).
 *
 * Pattern simple : div fixed inset overlay, focus trap basique via autofocus.
 */

import { useState, useEffect, useRef } from 'react';

/**
 * @param {{
 *   isOpen: boolean,
 *   docLabel?: string,
 *   onConfirm: (reason: string) => void,
 *   onCancel: () => void,
 * }} props
 */
export default function RejectModal({ isOpen, docLabel = 'le document', onConfirm, onCancel }) {
  const [reason, setReason] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setReason('');
      // Focus avec tick pour eviter race avec render
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const submit = () => {
    const trimmed = reason.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Raison du rejet"
    >
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-5">
        <h3 className="text-lg font-bold text-[#0f172a] mb-2">Rejeter {docLabel}</h3>
        <p className="text-sm text-[#64748b] mb-3">
          Indique la raison du rejet (sera visible dans la timeline).
        </p>
        <textarea
          ref={inputRef}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Ex: pieces illisibles, periode invalide, ..."
          rows={3}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-red-300 focus:outline-none"
        />
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-[#475569] hover:bg-gray-50 rounded-lg"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={submit}
            disabled={!reason.trim()}
            className="px-4 py-2 text-sm font-medium bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Confirmer le rejet
          </button>
        </div>
      </div>
    </div>
  );
}
